const TASK_STATUS_STYLES: Record<
  number,
  { backgroundColor: string; color: string }
> = {
  1: {
    backgroundColor: '#e9f8f0',
    color: '#187a4d',
  },
  2: {
    backgroundColor: '#fff8e8',
    color: '#b66f00',
  },
  3: {
    backgroundColor: '#e9f8f0',
    color: '#187a4d',
  },
  4: {
    backgroundColor: '#fff1f1',
    color: '#c9362c',
  },
}

const getColorByStatus = (
  statusId?: number | null
): { backgroundColor: string; color: string } | undefined => {
  return statusId ? TASK_STATUS_STYLES[statusId] : undefined
}

export { getColorByStatus }
